import React from 'react';
import { ScrollButton } from './Shared';
export const Hero = () => {
  return <section className="relative overflow-hidden" data-id="element-80" data-mp="ejwgd0gzbv21">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 min-h-[100svh] sm:min-h-0 flex flex-col justify-center py-4 sm:pt-16 sm:pb-16" data-id="element-81" data-mp="eiboxjpyos8e">
        <div className="text-center w-full hero-enter" data-id="element-82" data-mp="4lqkazhutj53">
          <p className="text-brand-terracotta font-semibold text-[10px] sm:text-sm tracking-[0.2em] uppercase mb-2 sm:mb-5" data-id="element-83" data-mp="4n9z0lnv3m4r">
            PROFE LISTO · PILATES 360
          </p>

          <h1 className="text-[26px] leading-[1.1] sm:text-5xl md:text-6xl font-serif font-bold text-brand-charcoal sm:leading-[1.05] mb-3 sm:mb-10" data-id="element-84" data-mp="xbfk59itvd54">
            Todo tu año de Pilates resuelto de una vez.
          </h1>

          <div className="mb-3 sm:mb-10 hero-product-enter" data-id="element-85" data-mp="nboo33emcq2x">
            <img src="https://cdn.magicpatterns.com/uploads/mEctmTYqC3uRDkeDUrUZxH/52.png" alt="Megapack Pilates 360" loading="eager" fetchPriority="high" decoding="async" width="600" height="600" className="mx-auto h-[42vh] sm:h-auto sm:w-full sm:max-w-md object-contain" data-id="element-86" data-mp="3d21v45faeyrf" />
          </div>

          <p className="text-xs sm:text-lg text-gray-600 leading-snug sm:leading-relaxed mb-3 sm:mb-8 max-w-md mx-auto px-2" data-id="element-87" data-mp="399bavmrkdbvg">
            Megapack PILATES 360 — El sistema completo de sesiones y
            planificación para el profesor de Pilates argentino
          </p>

          <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-3 mb-3 sm:mb-8" data-id="element-88" data-mp="358howyxom757">
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-89" data-mp="2qkdc2blb8puc">
              📄 PDF
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-90" data-mp="2hkgj3xrw14th">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-91" data-mp="2lla70r5byjmd">
              ⚡ Acceso Inmediato
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-92" data-mp="n9qjjcaquy90">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-3 py-1.5 sm:px-4 sm:py-2 text-[11px] sm:text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-93" data-mp="ibgnkzh73tmc">
              📚 12 Tomos + 6 Bonus + 2 Élite
            </span>
          </div>

          <ScrollButton className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-sm sm:text-lg font-bold py-3.5 sm:py-4 px-6 sm:px-8 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-94" data-mp="161t1qs31amld">
            💪 QUIERO MI PILATES 360 AHORA
          </ScrollButton>

          <div className="mt-2.5 sm:mt-5 flex flex-wrap justify-center items-center gap-x-2 gap-y-1 sm:gap-x-3 sm:gap-y-2 text-[10px] sm:text-sm text-gray-600" data-id="element-95" data-mp="3lu9xn2arm0br">
            <span className="flex items-center gap-1" data-id="element-96" data-mp="1xacfj35u5jt8">🛡️ Garantía 7 días</span>
            <span className="text-gray-300" data-id="element-97" data-mp="21aeirgr7ylam">|</span>
            <span className="flex items-center gap-1" data-id="element-98" data-mp="21b61vs3mqqk0">🔒 Pago seguro</span>
            <span className="text-gray-300" data-id="element-99" data-mp="2697lqf8vqtwj">|</span>
            <span className="flex items-center gap-1" data-id="element-100" data-mp="2b0plx132wqgg">
              💳 Tarjetas y transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
};